var Variant;
(function (Variant) {
    Variant["primary"] = "primary";
    Variant["secondary"] = "secondary";
    Variant["ghost"] = "ghost";
    Variant["link"] = "link";
})(Variant || (Variant = {}));
var Alignment;
(function (Alignment) {
    Alignment["left"] = "left";
    Alignment["center"] = "center";
    Alignment["right"] = "right";
    Alignment["justify"] = "justify";
})(Alignment || (Alignment = {}));
var VerticalAlignment;
(function (VerticalAlignment) {
    VerticalAlignment["top"] = "top";
    VerticalAlignment["center"] = "center";
    VerticalAlignment["bottom"] = "bottom";
})(VerticalAlignment || (VerticalAlignment = {}));
var DSSize;
(function (DSSize) {
    DSSize["small"] = "small";
    DSSize["default"] = "default";
    DSSize["large"] = "large";
})(DSSize || (DSSize = {}));
var DividerTypeEnum;
(function (DividerTypeEnum) {
    DividerTypeEnum["text"] = "text";
    DividerTypeEnum["icon"] = "icon";
})(DividerTypeEnum || (DividerTypeEnum = {}));
var DividerStyleEnum;
(function (DividerStyleEnum) {
    DividerStyleEnum["solid"] = "solid";
    DividerStyleEnum["double"] = "double";
    DividerStyleEnum["dotted"] = "dotted";
    DividerStyleEnum["dashed"] = "dashed";
})(DividerStyleEnum || (DividerStyleEnum = {}));

export { Alignment, DSSize, DividerStyleEnum, DividerTypeEnum, Variant, VerticalAlignment };
